import React from "react";
import AddItemForm from "../components/AddItemForm";
import ListItems from "../components/ListItems";

export default function ProductPage() {
  return (
    <div style={{ padding: 20 }}>
      <h2>General Products</h2>

      <AddItemForm
        endpoint="product/create/"
        successMessage="Product added!"
        fields={[
          { name: "name", label: "Name", type: "text" },
          { name: "description", label: "Description", type: "textarea" },
          { name: "price", label: "Price", type: "number" },
          { name: "stock", label: "Stock", type: "number" },
          { name: "category", label: "Category", type: "text" },
          { name: "image", label: "Image", type: "file" },
        ]}
      />

      <hr />
      <ListItems endpoint="product/list/" title="Products" />
    </div>
  );
}
